module.exports = __webpack_public_path__ + "img/HZ-P1013.bcfb80a7.jpg";